import { render, staticRenderFns } from "./TournamentMode.vue?vue&type=template&id=0d2007d4&scoped=true&"
import script from "./TournamentMode.vue?vue&type=script&lang=js&"
export * from "./TournamentMode.vue?vue&type=script&lang=js&"
import style0 from "./TournamentMode.vue?vue&type=style&index=0&id=0d2007d4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d2007d4",
  null
  
)

export default component.exports